import PointIcon from '../../assets/point-icon.svg';
import RankBadge from '../RankBadge';

export const WriterBadgeInfo = ({ rank, totalReceivedPoint, totalReceivedUsers }) => {
  return (
    <div className="w-max p-2 md:p-4 rounded-[14px] bg-[#E6E7EB] shadow-[0px_0px_8px_0px_#00000024]">
      <div className="flex items-center justify-between gap-4 mb-1">
        <span className="text-growth-green-900 text-[10px] md:text-xs font-[600]">
          Writer Rank:
        </span>
        <RankBadge rank={rank} />
      </div>
      <p className="text-growth-green-900 text-[10px] md:text-xs font-[400]">
        Writer's earned recognition:
      </p>
      <div className="flex items-center gap-1 text-growth-green-900 mt-1">
        <img src={PointIcon} className="w-4 h-4" alt="" />
        <p className="font-[800] text-[10px] md:text-xs">
          {totalReceivedPoint || 0} {totalReceivedPoint === 1 ? 'Twig' : 'Twigs'} •{' '}
          <span className="font-[400]">
            {totalReceivedUsers || 0} {totalReceivedUsers === 1 ? 'Reader' : 'Readers'}
          </span>
        </p>
      </div>
    </div>
  );
};
